<div class="onboarding-container">
  <h2>Welcome! Let's get you set up.</h2>
  
  <form [formGroup]="onboardingForm">
    <!-- Name -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="name">Name</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="name" type="text" id="name" placeholder="Full Name" />
      </nz-form-control>
    </nz-form-item>


    <!-- Phone -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="phone">Phone</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="phone" type="tel" id="phone" placeholder="Phone Number" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="email">E-mail</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="email" type="email" id="email" placeholder="Email" />
      </nz-form-control>
    </nz-form-item>

    
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="dob" nzRequired>Date of Birth</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="dob" type="date" id="dob" placeholder="YYYY-MM-DD" />
      </nz-form-control>
    </nz-form-item>

    <!-- Address with Google Places Autocomplete -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="address">Address</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <input nz-input formControlName="address" type="text" id="address" placeholder="Type full address" />
      </nz-form-control>
    </nz-form-item>

    <!-- Shirt Size -->
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="shirtSize">Shirt Size</nz-form-label>
      <nz-form-control [nzSpan]="14">
        <nz-select formControlName="shirtSize" id="shirtSize" nzPlaceHolder="Select a size">
          <nz-option *ngFor="let size of shirtSizes" [nzLabel]="size" [nzValue]="size"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    
<!-- Image Upload -->
<nz-form-item>
  <nz-form-label [nzSpan]="6" nzFor="badgeImg">Headshot Photo</nz-form-label>
  <nz-form-control [nzSpan]="14">
    <button nz-button nzType="default" (click)="fileInput.click()">
      <i nz-icon nzType="upload"></i> 
      {{ currentUser?.headshotUrl ? 'Change Photo' : 'Upload Headshot / Take Photo (No hats)' }}
    </button>
    <input
      #fileInput
      type="file"
      accept="image/*"
      (change)="onFileSelected($event)"
      style="display: none;"
    />

    <div *ngIf="imageUrl" style="margin-top: 12px;">
      <img
        [src]="imageUrl"
        alt="Uploaded Image Preview"
        style="
          border-radius: 50%;
          width: 120px;
          height: 120px;
          object-fit: cover;
          border: 1px solid #d9d9d9;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        "
      />
    </div>
  </nz-form-control>
</nz-form-item>

    <!-- Signature Required Table -->
    <nz-table #signatureTable [nzData]="documents" [nzLoading]="docLoading" [nzBordered]="true" nzSize="middle">
      <thead>
        <tr>
          <th>Document Name</th>
          <th>Action</th>
          <!-- <th>Completed?</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of signatureTable.data">
          <td>{{ doc.name }}</td>
          <td>
            <!-- Disable the button if the document is completed -->
            <button nz-button nzType="primary" (click)="signDocument(doc)" [disabled]="doc.completed">Sign</button>
          </td>
          <!-- <td> -->
            <!-- Display completion status with a disabled checkbox -->
            <!-- no point showing this cause reload just hides the doc -->
            <!-- <input type="checkbox" [checked]="doc.completed" disabled /> -->
          <!-- </td> -->
        </tr>
      </tbody>
    </nz-table>

    <!-- list of quizzes needed to be taken -->
    <nz-table #quizzesTable [nzData]="neededQuizzes" [nzLoading]="false" [nzBordered]="true" nzSize="middle">
      <thead>
        <tr>
          <th>Quiz Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let quiz of quizzesTable.data">
          <td>{{ quiz.name }}</td>
          <td>
            <button nz-button nzType="primary" (click)="takeQuiz(quiz.quiz_id)">Take Quiz</button>
          </td>
        </tr>
      </tbody>
    </nz-table>

    <br />

    <!-- Submit Button -->
    <nz-form-item>
      <nz-form-control [nzSpan]="14" [nzOffset]="6">
        <button [nzLoading]="submitting" nz-button nzType="primary" type="submit" (click)="onSubmit()" [disabled]="!(onboardingForm.valid && (documents?.length || 0) == 0 && (neededQuizzes?.length || 0) == 0 && badgeImg)">Submit</button>
      </nz-form-control>
    </nz-form-item>
  </form>

</div>

<nz-modal nzWidth="95%" [(nzVisible)]="docModal" nzFooter="null" nzMaskClosable="false" nzTitle="Document Signing" (nzOnCancel)="closeDoc()">
  <ng-container *nzModalContent>
    <div class="app">
      <docuseal-form
      [src]="docToken"
      [email]="currentUser?.email"
      (onLoad)="docOpened($event)"
      (onComplete)="docCompleted($event)">
    </docuseal-form>
    </div>
  </ng-container>
</nz-modal>
